import React, { useEffect,useState} from "react";
import Analysis from "./Analysis";
import QuestionBox from "./question.ans";
import { useSelector, useDispatch } from "react-redux";
import {
  getQuestions,
  setQuestions,
  setTitle,
} from "../../features/Questions/questionSlice";
import firebase, { db } from "./../firebase";
import { getTitle } from "./../../features/Questions/questionSlice";
// import { useHistory, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import Header from "./Header";
import "./index.css";
function Result() {
  // const history = useHistory();
  const Questions = useSelector(getQuestions);
  const title = useSelector(getTitle);
  var { id } = useParams();
  id = atob(id);
  const dispatch = useDispatch();
  const [score, setscore] = useState([]);
  const giveDataToParent = (score) =>{
    setscore(score);
    // console.log(score);
  }

  useEffect(() => {
    window.scrollTo(0,0);
    if (!Questions.length  || id !== title) {
      firebase.auth().onAuthStateChanged(function (user) {
        const docRef = db.collection("Answers").doc(user.email);
        docRef
          .get()
          .then((data) => data.exists && data.data()[id])
          .then((data) => {
            dispatch(setQuestions(data));
            dispatch(setTitle(id));
            // console.log("fetched...");
          })
          .catch((err) => console.error(err));
      });
    }
  }, []);

  return (
    <div className="temp-analysis">
      {" "}
      {id === title ? (
        <div className="analysis d-flex flex-column justify-content-center align-items-center ">
          {/* <Header score={score} /> */}
          <div className="analytics  ">
            <Analysis giveDataToParent = {giveDataToParent} />
          </div>
          <div>
            {" "}
            <QuestionBox />
          </div>
        </div>
      ) : (
        <div className="lds-dual-ring"></div>
      )}
    </div>
  );
}

export default Result;
